import SyncBase from 'eflex/models/kinetic-config/sync-base';

export default class KineticConfigBom extends SyncBase {}
